"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var WaterTap = function WaterTap(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.18 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.06,10.77h-.81a.12.12,0,0,0-.12.12v1h-6.8V6.16a.12.12,0,0,0,0-.07,2.89,2.89,0,0,0-2-1.06l0-2.45H15.7a.12.12,0,0,0, .12-.12V.93A.12.12,0,0,0,15.7.81H12.28V.12A.12.12,0,0,0,12.16,0H10.33a.12.12,0,0,0-.12.12V.81H7a.12.12,0,0,0-.12.12V2.23A.12.12,0,0,0,7, 2.34h3l0,2.73A1.7,1.7,0,0,0,8.48,6.71L8,11l-3.44.6a4.53,4.53,0,0,0-2.06.63A4.57,4.57,0,0,0,.47,16.49v2.35A.12.12,0,0,0,.59,19H3.77a.12.12,0, 0,0,.12-.12V17.26A1.92,1.92,0,0,1,6,15.39a3.75,3.75,0,0,1,2.48.76,4.32,4.32,0,0,0,2.86.81,4.62,4.62,0,0,0,3.26-1.57h6.61v1.27a.12.12,0,0,0, .12.12h.75a.12.12,0,0,0,.12-.12V10.89A.12.12,0,0,0,22.06,10.77Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.18,19.73a.34.34,0,0,0-.27-.19.3.3,0,0,0-.28.13.49.49,0,0,0,0,.51A.92.92,0,0,1,.52,21a2.9,2.9,0,0,0-.33,2.64.34.34,0,0,0,.31.22.32.32,0,0,0, .24-.11.49.49,0,0,0,.07-.51,2,2,0,0,1,.3-1.78A1.93,1.93,0,0,0,1.18,19.73Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.42,19.65a.29.29,0,0,0-.28.13.5.5,0,0,0,0,.51.93.93,0,0,1-.07.85,2.9,2.9,0,0,0-.33,2.65A.34.34,0,0,0,3,24a.32.32,0,0,0,.24-.11.49.49,0,0,0,.07-.51,2,2, 0,0,1,.3-1.78,1.93,1.93,0,0,0,.08-1.77A.33.33,0,0,0,3.42,19.65Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.44,19.73a.33.33,0,0,0-.27-.19.32.32,0,0,0-.28.13.49.49,0,0,0,0,.51.93.93,0,0,1-.07.85,2.89,2.89,0,0,0-.33,2.64.34.34,0,0,0,.31.22A.32.32,0,0,0,2, 23.78a.49.49,0,0,0,.07-.51,2,2,0,0,1,.3-1.78A1.93,1.93,0,0,0,2.44,19.73Z"
  }));
};

var _default = WaterTap;
exports["default"] = _default;